import * as React from "react";
import { connect } from "react-redux";
import * as Actions from "../../../redux/actions";
import { AppState } from "../../../redux";
import { SetSettingsMenuAction, SetSettingsMenuPayload } from "../../../redux/account/types";
import { ChangePassword } from "./change-password";
import { ChangeEmail } from "./change-email";
import { AccountDeactivation } from "./account-deactivation";
import { SETTING_SIGN_IN_AND_SECURITY } from "../../../redux/account/constants";

interface MapDispatchProps {
  setSettingsMenu: (payload: SetSettingsMenuPayload) => SetSettingsMenuAction;
}

interface MapStateProps {
  currentMenu: string | null;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { currentMenu } = props;
  const notCurrentMenu = currentMenu !== SETTING_SIGN_IN_AND_SECURITY;
  const isDefaultMenu = currentMenu === null;

  if (notCurrentMenu && !isDefaultMenu) {
    return null;
  }
  return (
    <>
      <h3>{SETTING_SIGN_IN_AND_SECURITY}</h3>
      <ChangeEmail />
      <ChangePassword />
      <AccountDeactivation />
    </>
  );
};

const mapState = (state: AppState) => ({
  currentMenu: state.account.currentSettingsMenu,
});

const mapDispatch = {
  setSettingsMenu: Actions.setSettingsMenu,
};

export const SignInAndSecurity = connect(mapState, mapDispatch)(Component);
